import { Box, Button, Form, Icon, Spacer, Text } from '@jfs/ui-new'
import { useIsLargeScreen } from '@jfs/ui-new/src/utils/utils'
import { useNavigation } from '@react-navigation/native'
import { observer } from 'mobx-react'
import { FC, useCallback, useEffect, useState } from 'react'
import ErrorAlert from '../../comps/Alert/ErrorAlert'
import { AlertTypes } from '../../comps/Alert/index'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { Progress } from '../../comps/Progress'
import { ToastType } from '../../comps/Toast'
import { forgotPwdStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { useIsMobile } from '../../util/useFontSize'
import { isMobile, isOsMobile, ProgressTypes, testProps, useWindowDimensions } from '../../util/util'
import { LoginBg } from '../Login/LoginBg'
import { pwdStrengthCbData, resetForm } from './FormData'
import ResetPwdMoile from './ResetPwdMoile'
import { styles } from './styles'

interface ResetPasswordProps {
  show?: boolean
  otp?: string
  isSignUp?: boolean
  route?: any
}

const handleLogin = (
  resetState: string | undefined,
  loginState: string | undefined,
  resetStateData: any,
  mobileNum: string,
  password: string,
  handleInvalidOtp: () => void,
  handleNavigation: (s: string) => void,
  login: (usr: string, password: string) => void,
  isSignUp: boolean,
) => {
  if (resetState === 'fulfilled' && !loginState) {
    if (resetStateData && resetStateData?.status === 'SUCCESS') {
      if (isSignUp) {
        login(mobileNum, password)
      } else {
        handleNavigation('fulfilled')
      }
    } else {
      handleInvalidOtp()
    }
  }
  if (loginState === 'fulfilled' || loginState === 'rejected') {
    handleNavigation(loginState)
  }
  if (resetState === 'rejected') {
    handleInvalidOtp()
  }
}

const ResetPassword: FC<ResetPasswordProps> = ({ route: { params } }: ResetPasswordProps) => {
  const show = true
  const otp = params?.otp
  const isSignUp = params?.isSignUp

  const isLargeScreen = useIsLargeScreen()

  const {
    forgotResetPassword,
    verifyCredentials,
    mobileNum,
    onboardMerchant,
    isUserNotFoundInIdam,
    setPasswordForIdam,
    setMessage,
    setToastType,
  } = useStores((root) => ({
    forgotResetPassword: root.user.forgotResetPassword,
    verifyCredentials: root.user.session.verifyCredentials,
    mobileNum: root.settings.metaData.mobileNumber,
    onboardMerchant: root.user.onboardMerchant,
    isUserNotFoundInIdam: root.settings.metaData.isUserNotFoundInIdam,
    setPasswordForIdam: root.user.setPasswordOnIDAM,
    setMessage: root.response.setMessage,
    setToastType: root.response.setToastType
  }))

  const [login, loginHandler] = useLazyApiData(verifyCredentials)
  const [resetPassword, resetHandler] = useLazyApiData(forgotResetPassword)
  const [signUpMerchant, signUpMerchantHandler] = useLazyApiData(onboardMerchant)
  const [setIdamPwd, idamPwdHandler] = useLazyApiData(setPasswordForIdam)

  const [confPassword, setConfPassword] = useState('')
  const initData = { password: '', passwordConfirm: '' }

  const navigation = useNavigation()

  const handleNavigation = useCallback(
    (state: string): any => {
      if (state === 'fulfilled') {
        if (isSignUp) {
          navigation.navigate(Routes.ADD_ACCNT)
        } else {
          setToastType(ToastType?.POSITIVE)
          setMessage(
            isUserNotFoundInIdam
              ? 'Password set successfully. Please login'
              : 'Password changed successfully. Please login',
          )
          navigation.reset({
            index: 0,
            routes: [
              {
                name: Routes.LOGIN,
              },
            ],
          })
        }
      } else {
        navigation.reset({
          index: 0,
          routes: [
            {
              name: Routes.LOGIN,
            },
          ],
        })
      }
    },
    [isSignUp, isUserNotFoundInIdam, navigation, setMessage],
  )

  const handleInvalidOtp = (): any => {
    navigation.reset({
      index: 0,
      routes: [
        {
          name: Routes.FORGOT_PASSWORD,
          params: { path: Routes.FORGOT_PASSWORD },
        },
      ],
    })
  }

  const viewPortWidth = useWindowDimensions()

  useEffect(() => {
    handleLogin(
      resetHandler.state,
      loginHandler.state,
      resetHandler?.data,
      mobileNum,
      confPassword,
      handleInvalidOtp,
      handleNavigation,
      login,
      isSignUp,
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login, loginHandler.state, resetHandler.state])

  useEffect(() => {
    handleLogin(
      idamPwdHandler.state,
      loginHandler.state,
      idamPwdHandler?.data,
      mobileNum,
      confPassword,
      handleInvalidOtp,
      handleNavigation,
      login,
      isSignUp,
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login, loginHandler.state, idamPwdHandler.state])

  useEffect(() => {
    if (signUpMerchantHandler.state === 'fulfilled') {
      handleNavigation(signUpMerchantHandler.state)
    }
  }, [handleNavigation, signUpMerchantHandler.state])

  if (!show) {
    return null
  }
  const isLoading = loginHandler.state === 'pending' || resetHandler.state === 'pending'
  const otpError =
    //Invalid otp case error code
    resetHandler?.data?.error?.code === '22417' ||
    resetHandler?.data?.error?.message?.includes('otp') ||
    resetHandler?.data?.message?.includes('otp') ||
    resetHandler?.data?.message?.includes('OTP') ||
    resetHandler?.data?.message?.includes('Failed')
      ? 'Oops! Your OTP is invalid. You can retry to continue.'
      : ''
  const otpErrorVisible = otpError?.length > 0
  const handleAlertBtnPress = (): void => {
    navigation.reset({
      index: 0,
      routes: [
        {
          name: Routes.OTP,
          params: { path: Routes.OTP, isSignUp: isSignUp },
        },
      ],
    })
  }

  const handleBack = () => {
    navigation?.goBack()
  }

  const hideStepProgress = () => {
    return true //TODO: for mobile need not to show  as per design have a check for web to show there once merged with web
  }

  const getFormData = (): any[] => {
    const initialFormData = [...resetForm()]
    return initialFormData
  }

  const renderActionButtons = ({ values, isCurrentFormValid }: any) => {
    const handleResetPassword = () => {
      setConfPassword(values.password)
      if (!isSignUp) {
        // if (!isUserNotFoundInIdam) {
        //   resetPassword(mobileNum, values.password, otp)
        // } else {
        //   setIdamPwd(mobileNum, values.password, otp)
        // }
        setIdamPwd(mobileNum, values.password, otp)
      } else {
        signUpMerchant(mobileNum, values.password, otp)
      }
    }
    return (
      <Box {...styles(viewPortWidth).buttonContainer}>
        <Button
          disabled={
            !isCurrentFormValid ||
            values.password !== values.passwordConfirm ||
            values.checklist?.length < pwdStrengthCbData.length
          }
          isLoading={isLoading}
          type={'primary'}
          color={'BLUE'}
          {...testProps('reset-button')}
          isFull
          onPress={handleResetPassword}>
          <Text color={'WHITE'}>{isSignUp ? forgotPwdStrings.setPwdAndSignUp : forgotPwdStrings.setPwdAndLogin}</Text>
        </Button>
      </Box>
    )
  }

  const isMob = useIsMobile()
  if (isMob) {
    return <ResetPwdMoile params={params}/>
  }
  return (
    <LoginBg isSignup={isSignUp}>
      <Box paddingTop={16} ph={8} minWidth={viewPortWidth > 432 ? 320 : viewPortWidth - 36}>
        <ModBox show={isOsMobile()} testID="arrow-back" onPress={handleBack} {...styles(viewPortWidth).imgStyle}>
          <Icon id={'ARROW_BACK'} color={'PRIMARY'} size={24} />
        </ModBox>
        <Spacer size={10} />
        <Progress hide={hideStepProgress()} type={ProgressTypes.RESET_PWD} />
        <ErrorAlert
          type={AlertTypes.Error}
          visible={otpErrorVisible}
          onPress={handleAlertBtnPress}
          subTitle={otpError ?? ''}
          onAction={handleAlertBtnPress}
          buttonLabel={'Retry'}
        />
        <Box pl={16}>
          <Text {...styles(viewPortWidth).titleStyle}>
            {isSignUp ? forgotPwdStrings.setUrPassword : forgotPwdStrings.resetPassword}
          </Text>
        </Box>
        <Box>
          {isMobile(isLargeScreen) ? (
            <Form
              initialValues={initData}
              formData={getFormData()}
              actionButtons={renderActionButtons}
              container={FormContainer}
            />
          ) : (
            <Form
              initialValues={initData}
              formData={getFormData()}
              actionButtons={renderActionButtons}
              container={FormContainer}
            />
          )}
        </Box>
      </Box>
    </LoginBg>
  )
}

const FormContainer = ({ children }) => {
  const viewPortWidth = useWindowDimensions()
  return <Box {...styles(viewPortWidth).webFormContainer}>{children}</Box>
}

export default observer(ResetPassword)
